<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
};
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=EB+Garamond');
  @import url('https://fonts.googleapis.com/css?family=Signika');

  @import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,700');

                                                                                                                              #app {
    display: flex;
    align-items: center;
    justify-content: center;

    font-family: 'Signika', 'Source Sans Pro', sans-serif;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }


  a {
    background-color: transparent;

    color: #9c554b;
    text-decoration: none;

    &.focus {
      background-color: #ebe9e8 !important;
      padding-left:14px;
      padding-right:2px;
      background: url('assets/arrow.png');
      background-repeat: no-repeat;
      background-position-y: 5px;
      background-position-x: 4px;
      display: inline-block;
    }
  }

  /* common stuff */
  a {}
  img {max-width: 100%;}

  h1 {
    font-family: 'EB Garamond', serif;
    color: #9c554b;
    font-variant: small-caps;
    font-weight: bold;
    line-height: 1.5rem;
    font-size:1.5rem;
  }

  h2 {
    font-family: 'EB Garamond', serif;
    color: #9c554b;
    font-variant: small-caps;
    line-height: 1.2rem;
    font-size:1.2rem;
    margin-bottom:1rem;
  }

  p, div {
    color : #9b7f7b;
  }

  // Flickity
   .flickity-viewport {
     overflow: hidden;
     height: 100%;
   }


  .carousel-cell {
    position: relative;
    top: 50%;
    transform: translateY(-50%);

    width: 100%;
    margin-right: 10px;
    border-radius: 5px;
    opacity: 0;

    transition: opacity 0.5s ease-in-out;
    text-align: center;

    &.is-selected {
       opacity: 1;
     }

    img {
      max-width: 100%;
    }
  }

  // Focus (button)

  button.focus {
    color: #9c554b;
    background-color: #ebe9e8 !important;
    padding-left: 11px;
    padding-right: 2px;
    border: 0;
    cursor: pointer;
    background: url('assets/arrow.png');
    background-repeat: no-repeat;
    background-position-y: center;
    background-position-x: 2px;
    
    &:hover {
      text-decoration: underline;
    }
    &:disabled {
      opacity: 0.5;
    }
  }


  // Colors
  .color {
    display: inline-block;
    width:33px;
    height:33px;
    margin: 5px;
    border: 3px #AAA solid;

    &.argent {background-image: url('assets/colors/color_argent.png');}
    &.gris_perle {background-image: url('assets/colors/color_gris_perle.png');}
    &.flanelle{background-image: url('assets/colors/color_flanelle.png');}
    &.canard{background-image: url('assets/colors/color_canard.png');}
    &.clematite{background-image: url('assets/colors/color_clematite.png');}
    &.gitane{background-image: url('assets/colors/color_gitane.png');}
    &.bleu_marine{background-image: url('assets/colors/color_bleu_marine.png');}
    &.emeraude{background-image: url('assets/colors/color_emeraude.png');}
    &.perrier{background-image: url('assets/colors/color_perrier.png');}
    &.laurier{background-image: url('assets/colors/color_laurier.png');}
    &.tilleul{background-image: url('assets/colors/color_tilleul.png');}
    &.ocre{background-image: url('assets/colors/color_ocre.png');}
    &.brique{background-image: url('assets/colors/color_brique.png');}
    &.new_brique{background-image: url('assets/colors/color_new_brique.png');}
    &.corrida{background-image: url('assets/colors/color_corrida.png');}
    &.chanel{background-image: url('assets/colors/color_chanel.png');}
    &.camel{background-image: url('assets/colors/color_camel.png');}
    &.poil_chameau{background-image: url('assets/colors/color_poil_chameau.png');}
    &.betterave{background-image: url('assets/colors/color_betterave.png');}
    &.marron_fonce{background-image: url('assets/colors/color_marron_fonce.png');}
    &.noir{background-image: url('assets/colors/color_noir.png');}
    &.rose_indien{background-image: url('assets/colors/color_rose_indien.png');}
    &.anis{background-image: url('assets/colors/color_anis.png');}
  }

  // table style

  table.cart-items {
    margin:auto;
    border-spacing: 0;
    width:100%;

    th {
      background-color: #654a45;
      text-align: left;
      padding:0.2rem 0.5rem;
      font-weight: normal;
      color: white;
    }

    tbody {
      tr {
        background-color: white;
        color: #654A45;
      }
    }
    tfoot tr td {
      border:1px transparent solid;
      color: #654A45;
      white-space: nowrap;
      &:nth-of-type(2) {
        padding-right: calc(30px + 1rem);
        font-weight: bold;
      }
    }


    tr {
      line-height: 1.5rem;

      &.sum {
        background-color: #dddcdb;

        td{
          border:1px transparent solid;
          &:nth-of-type(2) {

            padding-right: calc(30px + 1rem);
            font-weight: bold;
          }
        }
      }

      td {
        border:1px #DDD solid;
        width:100px;
        padding:0 .5rem;

        &:nth-of-type(1) {
          width:auto;
        }
        &:nth-of-type(2) {
          text-align: center;
        }
        &:nth-of-type(3) {
          text-align: center;
        }
        &:nth-of-type(4) {
          text-align: center;
          border-right: 1px transparent solid;
        }
        &:nth-of-type(5) {
          width:20px;
          border-left: 1px transparent solid;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue